import { COMMON_ERRORS } from 'modules/common/constants/errors.references';
import { SUB_ORDER_ERROR } from 'modules/sales/sub-orders/constants/sub-order.errors';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  ALREADY_COMPLETED: 'ALREADY_COMPLETED',
  INVALID_ORDER_STATUS: 'INVALID_ORDER_STATUS',
  SUBORDER_INVALID_STATUS: 'SUBORDER_INVALID_STATUS',
  // add new error refs here
};

export const PAID_ORDER_ERRORS = {
  [ERROR_REFS.ALREADY_COMPLETED]: {
    description: 'order:errors.ALREADY_COMPLETED',
  },
  [ERROR_REFS.INVALID_ORDER_STATUS]: {
    description: 'order:errors.INVALID_ORDER_STATUS',
  },
  [ERROR_REFS.SUBORDER_INVALID_STATUS]: {
    description: 'order:errors.SUBORDER_INVALID_STATUS',
  },
  [SUB_ORDER_ERROR.INVALID_ORDER_STATUS]: {
    description: 'order:errors.INVALID_ORDER_STATUS',
  },
  [SUB_ORDER_ERROR.IMPORT_STATUS_FILE_ERROR]: {
    description: 'order:errors.IMPORT_STATUS_FILE_ERROR',
  },
  [SUB_ORDER_ERROR.STATUS_NOT_ALLOWED]: {
    description: 'order:errors.STATUS_NOT_ALLOWED',
  },
};
